export const ContentSearchStyles: Record<string, any> = {
  contentTitle:
    'font-Lora text-28 md:text-30 tracking-0 mb-5 font-bold capitalize md:mb-7',
  wrapper: 'flex flex-col',
  contentRowWrapper: 'text-24 flex w-full flex-col border-b border-black py-7',
  pageNameDiv: 'font-Roboto font-medium w-full pb-2',
  descAndLinkWrapper: 'flex flex-col md:flex-row',
  description: 'font-Roboto text-20 basis-1/2 text-justify',
  linkWrapper: 'basis-1/2 pt-4 text-left md:pt-0 md:text-right',
  rightArrowStyle:
    'text-32 leading-12 tracking-0 relative overflow-x-hidden py-2 outline-none',
  contentLinkStyle: 'font-Roboto font-medium text-20 overflow-hidden'
}
